
import { defineComponent } from "vue";
import FlowNodeWrapper from "@/components/bot/FlowNodeWrapper.vue";

export default defineComponent({
  name: "FlowNodeLoader",
  components: {
    FlowNodeWrapper,
  },
  props: {
    data: Object,
  },
});
